// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Read the Room results: donut + legend, shown inside a marquee card. */

.pieCard {
  /* Definite width so the marquee sizes to this card, not the unwrapped question. */
  width: 56rem;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: 0.5rem 0.75rem;
  /* The marquee card sets huge heading type; reset for this layout. */
  font-family: var(--font-body);
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.3;
  text-align: center;
  color: var(--ink);
}

.pieKicker {
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 1.1rem;
  color: var(--ink-soft);
}

.pieQuestion {
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 2.1rem;
  line-height: 1.15;
  margin: 0.15rem 0 1.4rem;
  overflow-wrap: anywhere;
}

.pieBody {
  display: flex;
  align-items: center;
  gap: 2.25rem;
}

.pieDonut {
  flex-shrink: 0;
  display: flex;
}

/* nivo emits an svg with inline sizing; keep it from picking up
   \`overflow: visible\` glow outside its box. */
.pieDonut svg {
  display: block;
  overflow: visible;
}

.pieCenter {
  fill: var(--ink);
  font-family: var(--font-heading);
  font-weight: 600;
}

.pieCenterNumber {
  font-size: 3rem;
}

.pieCenterLabel {
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 0.95rem;
  fill: var(--ink-soft);
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.pieLegend {
  flex: 1;
  min-width: 0;
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  text-align: left;
}

/* Rows echo the answer cards from the question screen. */
.pieLegendRow {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 0.5rem 0.9rem 0.5rem 0.6rem;
  background: #f3f8fe;
  border: 2px solid transparent;
  border-radius: var(--border-radius);
  min-height: 3.4rem;
  box-sizing: border-box;
  opacity: 0;
  transform: translateY(8px);
}

.marqueeItem.active .pieLegendRow {
  animation: marqueeCopyIn 0.42s calc(0.18s + var(--i, 0) * 0.07s) cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

.pieLegendRow.winner {
  background: #eef8fe;
  border-color: var(--navy);
}

.pieLegendRow.empty {
  color: var(--ink-soft);
}

.pieBadge {
  flex-shrink: 0;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 10px;
  display: grid;
  place-items: center;
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 1.3rem;
  line-height: 1;
}

.pieLegendText {
  flex: 1;
  min-width: 0;
  font-weight: 700;
  font-size: 1.15rem;
  overflow-wrap: anywhere;
}

.pieLegendRow.winner .pieLegendText {
  font-weight: 800;
}

.pieTag {
  flex-shrink: 0;
  background: var(--sky-strong);
  color: var(--ink);
  border-radius: var(--pill-radius);
  padding: 0.25rem 0.7rem;
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 0.85rem;
  line-height: 1.2;
  white-space: nowrap;
}

.pieTag.win {
  background: var(--navy);
  color: var(--white);
}

.pieLegendCount {
  flex-shrink: 0;
  min-width: 2ch;
  text-align: right;
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 1;
}

@media (max-width: 720px) {
  .pieBody {
    flex-direction: column;
    gap: 1.25rem;
  }

  .pieQuestion {
    font-size: 1.6rem;
  }

  .pieTag {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/browser/webapp/components/room/shared/pie.css"],"names":[],"mappings":"AAAA,wEAAwE;;AAExE;EACE,kFAAkF;EAClF,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,oEAAoE;EACpE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;8CAC8C;AAC9C;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,6BAA6B;EAC7B,mCAAmC;EACnC,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,wGAAwG;AAC1G;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,iCAAiC;EACjC,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Read the Room results: donut + legend, shown inside a marquee card. */\n\n.pieCard {\n  /* Definite width so the marquee sizes to this card, not the unwrapped question. */\n  width: 56rem;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  padding: 0.5rem 0.75rem;\n  /* The marquee card sets huge heading type; reset for this layout. */\n  font-family: var(--font-body);\n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 1.3;\n  text-align: center;\n  color: var(--ink);\n}\n\n.pieKicker {\n  font-family: var(--font-body);\n  font-weight: 700;\n  font-size: 1.1rem;\n  color: var(--ink-soft);\n}\n\n.pieQuestion {\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 2.1rem;\n  line-height: 1.15;\n  margin: 0.15rem 0 1.4rem;\n  overflow-wrap: anywhere;\n}\n\n.pieBody {\n  display: flex;\n  align-items: center;\n  gap: 2.25rem;\n}\n\n.pieDonut {\n  flex-shrink: 0;\n  display: flex;\n}\n\n/* nivo emits an svg with inline sizing; keep it from picking up\n   `overflow: visible` glow outside its box. */\n.pieDonut svg {\n  display: block;\n  overflow: visible;\n}\n\n.pieCenter {\n  fill: var(--ink);\n  font-family: var(--font-heading);\n  font-weight: 600;\n}\n\n.pieCenterNumber {\n  font-size: 3rem;\n}\n\n.pieCenterLabel {\n  font-family: var(--font-body);\n  font-weight: 700;\n  font-size: 0.95rem;\n  fill: var(--ink-soft);\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.pieLegend {\n  flex: 1;\n  min-width: 0;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n  text-align: left;\n}\n\n/* Rows echo the answer cards from the question screen. */\n.pieLegendRow {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  padding: 0.5rem 0.9rem 0.5rem 0.6rem;\n  background: #f3f8fe;\n  border: 2px solid transparent;\n  border-radius: var(--border-radius);\n  min-height: 3.4rem;\n  box-sizing: border-box;\n  opacity: 0;\n  transform: translateY(8px);\n}\n\n.marqueeItem.active .pieLegendRow {\n  animation: marqueeCopyIn 0.42s calc(0.18s + var(--i, 0) * 0.07s) cubic-bezier(0.22, 1, 0.36, 1) forwards;\n}\n\n.pieLegendRow.winner {\n  background: #eef8fe;\n  border-color: var(--navy);\n}\n\n.pieLegendRow.empty {\n  color: var(--ink-soft);\n}\n\n.pieBadge {\n  flex-shrink: 0;\n  width: 2.4rem;\n  height: 2.4rem;\n  border-radius: 10px;\n  display: grid;\n  place-items: center;\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 1.3rem;\n  line-height: 1;\n}\n\n.pieLegendText {\n  flex: 1;\n  min-width: 0;\n  font-weight: 700;\n  font-size: 1.15rem;\n  overflow-wrap: anywhere;\n}\n\n.pieLegendRow.winner .pieLegendText {\n  font-weight: 800;\n}\n\n.pieTag {\n  flex-shrink: 0;\n  background: var(--sky-strong);\n  color: var(--ink);\n  border-radius: var(--pill-radius);\n  padding: 0.25rem 0.7rem;\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 0.85rem;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.pieTag.win {\n  background: var(--navy);\n  color: var(--white);\n}\n\n.pieLegendCount {\n  flex-shrink: 0;\n  min-width: 2ch;\n  text-align: right;\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 1.5rem;\n  line-height: 1;\n}\n\n@media (max-width: 720px) {\n  .pieBody {\n    flex-direction: column;\n    gap: 1.25rem;\n  }\n\n  .pieQuestion {\n    font-size: 1.6rem;\n  }\n\n  .pieTag {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
